import React, { Component } from "react";
import { Button, Chip, FormControl, Grid, TextField } from "@material-ui/core";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import PhoneInput from "react-phone-input-2";
import "react-multi-email/style.css";
import "./orderNotifications.css";
import "react-phone-input-2/lib/style.css";
import {bindActionCreators} from "redux";
import {
    getBusinessOrderNotificationDetails, saveBusinessOrderNotificationDetails,
} from "../../../Actions/orderAction";
import {connect} from "react-redux";
import Alert from "../../../Helper/SimpleAlert/alert";

class OrderNotificationsLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emails: [],
            phoneNumbers: [],
            faxNumbers: [],
            phoneValue: undefined,
            faxValue: undefined,
            emailError: null,
            phoneNumbersError: false,
            faxNumbersError: false,
            showError:false,
        };

        this.callSaveBusinessOrderNotificationDetails = this.callSaveBusinessOrderNotificationDetails.bind(this);
    }

    componentDidMount() {
        if (this.props.user.BusinessUser.BusinessId !== undefined && this.props.user.BusinessUser.BusinessId !== "") {
            this.props.getBusinessOrderNotificationDetails(this.props.user.BusinessUser.BusinessId).then((data) => {
                if (data.results.ResponseCode === true) {
                    let emails = []
                    let phoneNo = []
                    let faxNo = []

                    if (data.results.Emails !== undefined && data.results.Emails !== null && data.results.Emails !== "") {
                        emails = data.results.Emails.split(',');
                    }

                    if (data.results.Phones !== undefined && data.results.Phones !== null && data.results.Phones !== "") {
                        phoneNo = data.results.Phones.split(',');
                    }

                    if (data.results.Faxes !== undefined && data.results.Faxes !== null && data.results.Faxes !== "") {
                        faxNo = data.results.Faxes.split(',');
                    }

                    this.setState({
                        emails: emails,
                        phoneNumbers: phoneNo,
                        faxNumbers: faxNo
                    })
                }
            });
        }
    }

    callSaveBusinessOrderNotificationDetails() {

        if (this.props.user.BusinessUser.BusinessId !== undefined && this.props.user.BusinessUser.BusinessId !== "") {
            let emails = ''
            let phoneNo = ''
            let faxNo = ''

            if (this.state.emails !== undefined && this.state.emails.length > 0) {
                emails = this.state.emails.join(",")
            }

            if (this.state.phoneNumbers !== undefined && this.state.phoneNumbers.length > 0) {
                phoneNo = this.state.phoneNumbers.join(",")
            }

            if (this.state.faxNumbers !== undefined && this.state.faxNumbers.length > 0) {
                faxNo = this.state.faxNumbers.join(",")
            }

            this.props.saveBusinessOrderNotificationDetails(this.props.user.BusinessUser.BusinessId, emails, phoneNo, faxNo).then(() => {
                this.setState({
                    showSuccess: true,
                    showError: false,
                    msg: 'Saved Successfully',
                });
            });
        }
    }

    handlePhoneNoKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            this.setState({ phoneNumbersError: false });

            var value = "+1" + this.state.phoneValue.trim();
            if (value && value.length >= 10 && value.length <= 16) {
                this.setState({
                    phoneNumbers: [...this.state.phoneNumbers, this.state.phoneValue],
                    value: "",
                    phoneValue: ""
                });
            } else {
                this.setState({ phoneNumbersError: true });
            }
        } else if (["Backspace"].includes(evt.key)) {
            if (this.state.phoneValue == "" && this.state.phoneNumbers.length > 0) {
                this.handlePhoneDelete(this.state.phoneNumbers.length - 1);
            }
        }
    };

    handleFaxNoKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            this.setState({ faxNumbersError: false });

            var value = this.state.faxValue.trim(); // "+1" +
            if (value && value.length >= 10 && value.length <= 16) {
                this.setState({
                    faxNumbers: [...this.state.faxNumbers, this.state.faxValue],
                    value: "",
                    faxValue: ""
                });
            } else {
                this.setState({ faxNumbersError: true });
            }
        } else if (["Backspace"].includes(evt.key)) {
            if (this.state.faxValue == "" && this.state.faxNumbers.length > 0) {
                this.handleFaxDelete(this.state.faxNumbers.length - 1);
            }
        }
    };

    handlePhoneChange = (evt) => {
        this.setState({
            phoneValue: evt,
        });
    };

    handleFaxChange = (evt) => {
        this.setState({
            faxValue: evt,
        });
    };

    handlePhoneDelete = (idx) => {
        this.setState({
            phoneNumbers: this.state.phoneNumbers.filter((i, index) => index !== idx),
        });
    };

    handleFaxDelete = (idx) => {
        this.setState({
            faxNumbers: this.state.faxNumbers.filter((i, index) => index !== idx),
        });
    };

    alertCallback = () => {
        this.setState({
            showError: false,
            showSuccess: false,
        })
    };

    render() {
        const { emails, phoneNumbers, phoneNumbersError, faxNumbers, faxNumbersError } = this.state;

        return (
            <div>
                <Grid container spacing={24}>
                    <Alert onClose={this.alertCallback} showSuccess={this.state.showSuccess} showError={this.state.showError}
                           Msg={this.state.msg} />
                </Grid>

                <Grid className={"eventDetailsPromoteGrid"}>
                    <section>
                        <div className={"eventDetailsPromoteWrapper"} container>
                            <div className={"eventDetailsPromoteFormWrapper"}>
                                <div class={"row"}>
                                    <div class={"col-25"}>
                  <span className={"eventDetailsPromoteInputLabel"}>
                    {"Your Email:"}
                  </span>
                                    </div>
                                    <div class="col-75">
                                        <div class="contentwidth">
                                            <ReactMultiEmail
                                                placeholder="Enter Emails"
                                                emails={emails}
                                                onChange={(_emails) => {
                                                    this.setState({ emails: _emails });
                                                }}
                                                validateEmail={(email) => {
                                                    return isEmail(email); // return boolean
                                                }}
                                                style={{ width: "100%" }}
                                                getLabel={(email, index, removeEmail) => {
                                                    return (
                                                        <Chip
                                                            label={email}
                                                            onDelete={() => removeEmail(index)}
                                                            variant="outlined"
                                                            style={{
                                                                margin: "2px",
                                                                fontSize: "11.5px",
                                                            }}
                                                        />
                                                    );
                                                }}
                                                className={"eventDetailsPromoteLongInputField"}
                                            />
                                            <p className={"createEventPromotePreviewText"}>
                                                {/*{emails.join("   ") || "email@example.com"}*/}
                                                Example: email@example.com, email@example.com
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class={"row"} style={{ marginTop: "-20px" }}>
                                    <div class={"col-25"}>
                                        <p className={"eventDetailsPromoteInputLabel"}>
                                            {"Your Phone Number:"}
                                        </p>
                                    </div>
                                    <div class={"col-75"}>
                                        <div class="contentwidth">
                                            <div
                                                style={{
                                                    border: phoneNumbersError
                                                        ? "1px solid tomato"
                                                        : "1px solid gray",
                                                    boxSizing: "border-box",
                                                    resize: "vertical",
                                                }}
                                            >
                                                {phoneNumbers.length > 0 &&
                                                phoneNumbers.map((item, index) => (
                                                    <Chip
                                                        label={item}
                                                        onDelete={() => this.handlePhoneDelete(index)}
                                                        // color="primary"
                                                        variant="outlined"
                                                        style={{
                                                            margin: "2px",
                                                            fontSize: "11.5px",
                                                        }}
                                                    />
                                                ))}

                                                <PhoneInput
                                                    value={this.state.phoneValue}
                                                    placeholder="Type phone numbers."
                                                    onKeyDown={this.handlePhoneNoKeyDown}
                                                    onChange={(e) => this.handlePhoneChange(e)}
                                                    country={"us"}
                                                    disableDropdown={true}
                                                    onlyCountries={["us"]}
                                                    disableCountryCode={true}
                                                    prefix={"+1"}
                                                    dropdownStyle={{
                                                        border: "none",
                                                        outline: "none !important",
                                                        outlineWidth: "0 !important",
                                                        boxShadow: "none",
                                                    }}
                                                    inputStyle={{
                                                        //   padding: "5px",
                                                        border: "none",
                                                        outline: "none !important",
                                                        outlineWidth: "0 !important",
                                                        boxShadow: "none",
                                                        width: "100%",
                                                    }}
                                                />
                                            </div>
                                            <p className={"createEventPromotePreviewText"}>
                                                {/*{phoneNumbers.join("  ") || "111-111-1111"}*/}
                                                Example: 111-111-1111, 111-111-1111
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"} style={{marginTop: "-20px"}}>
                                    <div className={"col-25"}>
                                        <p className={"eventDetailsPromoteInputLabel"}>
                                            {"Your Fax Number:"}
                                        </p>
                                    </div>
                                    <div className={"col-75"}>
                                        <div className="contentwidth">
                                            <div
                                                style={{
                                                    border: faxNumbersError
                                                        ? "1px solid tomato"
                                                        : "1px solid gray",
                                                    boxSizing: "border-box",
                                                    resize: "vertical",
                                                }}
                                            >
                                                {faxNumbers.length > 0 &&
                                                faxNumbers.map((item, index) => (
                                                    <Chip
                                                        label={item}
                                                        onDelete={() => this.handleFaxDelete(index)}
                                                        // color="primary"
                                                        variant="outlined"
                                                        style={{
                                                            margin: "2px",
                                                            fontSize: "11.5px",
                                                        }}
                                                    />
                                                ))}

                                                <PhoneInput
                                                    value={this.state.faxValue}
                                                    placeholder="Type fax numbers."
                                                    onKeyDown={this.handleFaxNoKeyDown}
                                                    onChange={(e) => this.handleFaxChange(e)}
                                                    country={"us"}
                                                    disableDropdown={true}
                                                    onlyCountries={["us"]}
                                                    disableCountryCode={false}
                                                    prefix={""}
                                                    dropdownStyle={{
                                                        border: "none",
                                                        outline: "none !important",
                                                        outlineWidth: "0 !important",
                                                        boxShadow: "none",
                                                    }}
                                                    inputStyle={{
                                                        //   padding: "5px",
                                                        border: "none",
                                                        outline: "none !important",
                                                        outlineWidth: "0 !important",
                                                        boxShadow: "none",
                                                        width: "100%",
                                                    }}
                                                />
                                            </div>
                                            <p className={"createEventPromotePreviewText"}>
                                                {/*{faxNumbers.join("  ") || "111-111-1111"}*/}
                                                Example: 1-111-111-1111, 1-111-111-1111
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class={"row"}>
                                    <div class={"col-25"}>
                                        <></>
                                    </div>
                                    <div class={"col-75"}>
                                        <Button
                                            variant={"contained"}
                                            class="contentwidth"
                                            style={{
                                                fontSize: "14px",
                                                backgroundColor: "green",
                                                padding: "10px 25px 10px 25px",
                                                color: "white",
                                                textTransform: "none",
                                                borderRadius: "5px",
                                                fontFamily:
                                                    "HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif",
                                            }}
                                            onClick={this.callSaveBusinessOrderNotificationDetails}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps=(state)=> {
    return {
        user: state.loginResponse.results
    }
};

const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        getBusinessOrderNotificationDetails,
        saveBusinessOrderNotificationDetails
    },dispatch)
};

export default connect(mapStateToProps,matchDispatchToProps) (OrderNotificationsLayout);

